import Vue from 'vue'

export function readSessionConfig(env = window) {
  const mode = env.VUE_APP_SESSION_MODE || 'legacy'
  if (!['legacy', 'dual', 'firebase'].includes(mode)) {
    throw new Error('Invalid VUE_APP_SESSION_MODE')
  }

  return {
    mode,
    tenantId: env.VUE_APP_FIREBASE_MERCHANT_TENANT_ID || '',
    firebase: {
      apiKey: env.VUE_APP_FIREBASE_API_KEY || '',
      authDomain: env.VUE_APP_FIREBASE_AUTH_DOMAIN || '',
      projectId: env.VUE_APP_FIREBASE_PROJECT_ID || '',
      appId: env.VUE_APP_FIREBASE_APP_ID || ''
    }
  }
}

export const sessionConfig = readSessionConfig()
export const PROVIDER_KEY = 'blytzpay_session_provider'
const pinned =
  sessionStorage.getItem(PROVIDER_KEY) || localStorage.getItem(PROVIDER_KEY)
const selection = Vue.observable({
  provider: ['legacy', 'firebase'].includes(pinned)
    ? pinned
    : sessionConfig.mode === 'firebase'
      ? 'firebase'
      : 'legacy'
})

export function usesFirebaseSession() {
  return selection.provider === 'firebase'
}

export function pinSessionProvider(value) {
  selection.provider = value
  sessionStorage.setItem(PROVIDER_KEY, value)
  localStorage.setItem(PROVIDER_KEY, value)
}

export function clearSessionProviderPin(value) {
  if (sessionStorage.getItem(PROVIDER_KEY) === value)
    sessionStorage.removeItem(PROVIDER_KEY)
  if (localStorage.getItem(PROVIDER_KEY) === value)
    localStorage.removeItem(PROVIDER_KEY)
}
